import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes';

// Import external libraries
require('es6-promise').polyfill();	// Polyfill for using Promises in IE11
import axios from 'axios';
import API from './API';

// Import External CSS
import './../node_modules/bulma/css/bulma.css';

Vue.use(VueRouter);
Vue.prototype.$http = axios;
Vue.prototype.$API = API;

// Initialise Router
const router = new VueRouter({
	routes: routes,
	mode: 'history'
});

export const eventBus = new Vue();

// Initialise App
new Vue({
	el: '#app',
	render: h => h(App),
	router: router
});



// WEBPACK FOOTER //
// ./src/main.js